import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const UserList = {
    Wrapper: styled.div `
    display: flex;
    flex-direction: column;
    max-height: 100%;
    padding: 0 1rem;
    ${media.medium} {
      padding: 0 0.5rem;
    }
  `,
    Header: styled.div `
    font-weight: bold;
    color: ${({ theme }) => theme.color.headerTextColor};
    padding: 1rem;
    margin-bottom: 0.5rem;
    ${media.medium} {
      margin: 0 1.5rem;
    }
  `,
    SubHeader: styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-top: 0.5rem;
    ${media.medium} {
      margin-right: 0;
      justify-content: flex-end;
    }
  `,
    CreateChatButton: styled.button `
    color: ${({ theme }) => theme.color.backgroundBrand};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    background-color: transparent;
    background-image: none;
    border-color: ${({ theme }) => theme.color.backgroundBrand};
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:hover {
      color: ${(props) => props.disabled
        ? ({ theme }) => theme.color.backgroundBrand
        : ({ theme }) => theme.color.background};
      background-color: ${(props) => props.disabled
        ? "transparent"
        : ({ theme }) => theme.color.backgroundBrand};
      border-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    &:disabled {
      opacity: 0.5;
    }
    ${media.medium} {
      font-weight: 200 !important;
      font-size: 0.8rem !important;
      padding: 0.175rem 0.35rem;
    }
  `,
    UserList: styled.ul `
    list-style-type: none;
    margin: 0px;
    overflow-y: auto;
    padding: 0;
    background-color: ${({ theme }) => theme.color.background};
  `,
    UserLine: styled.div `
    display: flex;
    gap: 10px;
    align-items: center;
    border: none;
    width: -webkit-fill-available;
    background: none;
    padding: 1rem 1rem 1rem 0;
    cursor: pointer;
    justify-content: space-between;
    &:hover {
      background-color: ${({ theme }) => theme.color.backgroundAside};
    }
    ${media.medium} {
      padding: 0 1rem;
    }
  `,
    UserCheckbox: styled.input `
    border-radius: 0.25rem;
    width: 1.2rem;
    height: 1.2rem;
    margin-top: 0.25rem;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid rgba(0, 0, 0, 0.25);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    &:checked {
      background-color: ${({ theme }) => theme.color.backgroundBrand};
      border-color: ${({ theme }) => theme.color.backgroundBrand};
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
    }
  `,
    ChannelSearchContainer: styled.div `
    flex-basis: 100%;
    background-color: ${({ theme }) => theme.color.background};
  `,
    ChannelSearchInputWrapper: styled.div `
    display: flex;
    flex-basis: 100%;
    align-items: center;
    height: 40px;
    background: ${({ theme }) => theme.color.background};
    border-radius: 8px;
    border: 1px solid #ced4da;
    &:focus-within {
      border-color: ${({ theme }) => theme.color.backgroundBrand};
    }
    ${media.medium} {
      margin-left: 0;
      height: 23px;
    }
  `,
    ChannelSearchInputIcon: styled.div `
    flex-basis: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    justify-content: start;
    padding-left: 10px;
  `,
    ChannelSearchInputText: styled.input `
    background: none;
    border: none;
    font-size: 16px;
    outline: none;
    flex-basis: 100%;
    color: ${({ theme }) => theme.color.textMuted};
    ::placeholder {
      color: ${({ theme }) => theme.color.textMuted};
    }
    ${media.medium} {
      font-size: 0.8rem;
    }
  `,
    InputGroup: styled.div `
    margin: 0.75rem 0;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    min-height: 38px;
  `,
    Input: styled.input `
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    position: relative;
    flex: 1 1 100%;
    margin-bottom: 0;
    display: block;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    &:focus {
      color: #495057;
      background-color: #fff;
      border-color: ${({ theme }) => theme.color.backgroundBrand};
      outline: 0;
      box-shadow: 0 0 0 0.5px ${({ theme }) => theme.color.backgroundBrand};
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    ${media.medium} {
      font-size: 0.8rem;
    }
  `,
    Button: styled.button `
    color: ${({ theme }) => theme.color.backgroundBrand};
    background-color: transparent;
    background-image: none;
    border-color: ${({ theme }) => theme.color.backgroundBrand};
    cursor: pointer;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  `,
};
export default UserList;
//# sourceMappingURL=UserList.styled.js.map